import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuthRole } from './AuthProvider.jsx'

export default function RequireRole({
  children,
  allowedRoles = null,
  redirectUnauthenticated = '/',
  redirectUnauthorized = '/',
}) {
  const location = useLocation()

  const {
    user,
    userRole,
    loading,
    isAuthenticated,
  } = useAuthRole()

  /**
   * Solange Session + Profil noch geladen werden,
   * noch keine Redirect-Entscheidung treffen.
   *
   * Sonst könnten wir bei einem Reload kurzzeitig
   * einen gültig eingeloggten User umleiten.
   */
  if (loading) {
    return (
      <main
        style={{
          maxWidth: 800,
          margin: '0 auto',
          padding: 16,
        }}
      >
        <p>Anmeldung wird geprüft …</p>
      </main>
    )
  }

  /**
   * Nicht eingeloggt.
   *
   * Aktuell leiten wir zurück auf "/".
   * Später kann "/" unsere zentrale Login-Seite werden.
   */
  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to={redirectUnauthenticated}
        replace
        state={{
          from: location.pathname,
        }}
      />
    )
  }

  /**
   * Wenn keine Rollen angegeben wurden,
   * reicht ein gültiger Login.
   *
   * Beispiel:
   *
   * <RequireRole>
   *   <CListPage />
   * </RequireRole>
   */
  if (!allowedRoles || allowedRoles.length === 0) {
    return children
  }

  /**
   * User ist eingeloggt, besitzt aber keine
   * der für diese Route zugelassenen Rollen.
   */
  if (!allowedRoles.includes(userRole)) {
    return (
      <Navigate
        to={redirectUnauthorized}
        replace
        state={{
          from: location.pathname,
          reason: 'unauthorized',
        }}
      />
    )
  }

  return children
}